<mbs-modal>
  <ng-container modal-header><span [innerHTML]="title"></span></ng-container>
  <ng-container modal-body>
    <mbs-alert
      *ngIf="!isMBSMode"
      [type]="alertType.warning"
      [icon]="true">
      <span [innerHTML]="'shared:computers.modals.installUpdateOnlineAccessAlertText' | i18next: { param: computerName }"></span>
    </mbs-alert>
    <span
      *ngIf="isMBSMode"
      class="text-md">
      <ng-container *ngIf="isInstallMode; else updateBody">
        <span [innerHTML]="'shared:computers.modals.installUpdateInstallText' | i18next: { computerName }"></span>
      </ng-container>
      <ng-template #updateBody>
        <span [innerHTML]="'shared:computers.modals.installUpdateUpdateText' | i18next: { computerName }"></span>
      </ng-template>
    </span>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      *ngIf="isMBSMode"
      [type]="'primary'"
      (click)="baseModal.save(true)">
      {{ okButton }}
    </mbs-button>
    <mbs-button (click)="onCloseButtonClick()">
      {{ 'shared:buttons.' + (isMBSMode ? 'cancel' : 'close') | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
